import { render, staticRenderFns } from "./NewChatDialog.vue?vue&type=template&id=cb51ac32&"
import script from "./NewChatDialog.vue?vue&type=script&lang=js&"
export * from "./NewChatDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewChatDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
